import { render, staticRenderFns } from "./xqList.vue?vue&type=template&id=0a39aa3a&scoped=true"
import script from "./xqList.vue?vue&type=script&lang=js"
export * from "./xqList.vue?vue&type=script&lang=js"
import style0 from "./xqList.vue?vue&type=style&index=0&id=0a39aa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a39aa3a",
  null
  
)

export default component.exports